export default [      
    { name:'libraryMode', path: '/libraryMode', component: () => import('@/views/library-mode/index'), meta: {
        roles: ['student']
    } }, 
]